export default __webpack_public_path__ + "static/media/pexels-thisisengineering-3862365.a12f2349.jpg";